import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import exportToPDF from '../util/exportToPDF';

import { showModal } from '../../../../actions/ModalActions';

import './ActionsBar.styles.less';

const ActionsBar = ({
  seatingChart,
  // tables,
  couple,
  onAddTable,
  onDeleteChart,
  tableUUIDs,
}) => {
  const tableCount = tableUUIDs.length;
  return (
    <section className="sc__actions-bar">
      <div className="sc__actions-bar__button-group">
        <button
          className="sc__actions-bar__button"
          onClick={() => onAddTable(tableCount)}
        >
          <i aria-hidden className="zolaicon zolaicon-plus" />
          <span className="sc__actions-bar__label">Add table</span>
        </button>
      </div>
      <div className="sc__actions-bar__button-group">
        <button
          className="sc__actions-bar__button sc__actions-bar__button--secondary"
          onClick={() => exportToPDF(couple, seatingChart)}
          disabled={tableCount === 0}
        >
          <i aria-hidden className="zolaicon zolaicon-download-file" />
          <span className="sc__actions-bar__label">Download</span>
        </button>
      </div>
      <div className="sc__actions-bar__button-group">
        <button
          aria-label="Delete chart"
          className="sc__actions-bar__button sc__actions-bar__button--secondary"
          onClick={() => onDeleteChart(seatingChart.uuid)}
        >
          <i aria-hidden className="zolaicon zolaicon-trash" />
        </button>
      </div>
    </section>
  );
};

ActionsBar.propTypes = {
  seatingChart: PropTypes.shape({
    uuid: PropTypes.string
  }),
  couple: PropTypes.shape({
    primary: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      display_name: PropTypes.string,
      seat_uuid: PropTypes.string,
      table_uuid: PropTypes.string,
      couple_role: PropTypes.string,
      isVisible: PropTypes.bool,
    }),
    partner: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      display_name: PropTypes.string,
      seat_uuid: PropTypes.string,
      table_uuid: PropTypes.string,
      couple_role: PropTypes.string,
      isVisible: PropTypes.bool,
    }),
  }),
  onAddTable: PropTypes.func.isRequired,
  onDeleteChart: PropTypes.func.isRequired,
  tableUUIDs: PropTypes.arrayOf(PropTypes.string),
};

const mapStateToProps = state => ({
  seatingChart: state.seatingChart.seatingChart,
  couple: state.guestRail.couple,
  tableUUIDs: state.seatingChart.orderedTableUUIDs,
});

const mapDispatchToProps = dispatch => ({
  onAddTable: (numTables, tables) => dispatch(showModal('NEW_TABLE_MODAL', { numTables, tables }, { size: 'sm' })),
  onDeleteChart: uuid => dispatch(showModal('DELETE_CHART_MODAL', { uuid }, { size: 'md' }))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActionsBar);



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/ActionsBar/ActionsBar.jsx